module.exports = __webpack_public_path__ + "assets/Annulus.3fc9d5563c82eeb995e59a6826e8b7cf.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Annulus.gmt
// module id = 902
// module chunks = 0